module.exports = __webpack_public_path__ + "img/1.c47f85c1.png";